import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResult } from '../models/ApiResult';
import { AdminUsuario } from '../models/AdminUsuario';
import { LookupData } from '../models/lookup';

@Injectable()
export class AdministrarService {

  myAppUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getUsers() {    
    return this.http.get(this.myAppUrl + 'api/administracion/GetUsers');
  }

  getUserByID(id: string) : Observable<AdminUsuario> {
    return this.http.get<AdminUsuario>(this.myAppUrl + `api/administracion/getuserbyauthid/${id}`);
  }

  updateUser(myUser: AdminUsuario): Observable<ApiResult> {
    return this.http.post<ApiResult>(this.myAppUrl + 'api/administracion/UpdateUser/', myUser);
  }

  deleteUser(idUsuario: number): Observable<ApiResult> {
    return this.http.delete<ApiResult>(this.myAppUrl + `api/administracion/DeleteUser/${idUsuario}`);
  }

  createUser(myUser: AdminUsuario): Observable<ApiResult> {
    return this.http.post<ApiResult>(this.myAppUrl + 'api/administracion/CreateUser/', myUser);
  }

  restablishPassword(id: string) {
    return this.http.get(this.myAppUrl + 'api/administracion/RestablishPassword/' + id);
  }
}
